import React, {useState, useEffect, Fragment} from 'react';

export interface iImage {
    key: string;
    imageUrl: string;
    altText: string;
    maxWidth?: string;
    maxHeight?: string;
}

export function SharedImage(props: iImage) {
    return <div
        style={{
            width: '100%',
            height: props.maxHeight ? 'auto' : '100%',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: props.maxWidth || props.maxHeight ? '1rem 0' : undefined
        }}
    >
        <img
            src={props.imageUrl}
            alt={props.altText}
            style={{
                maxWidth: props.maxWidth || '100%',
                maxHeight: props.maxHeight || '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                display: 'block'
            }}
        />
    </div>
}

export default SharedImage;